import { createNodeEnvDevToolboxEnabled } from "@mcblessing1/dev-toolbox-core";

/**
 * Single guard for dev toolbox mount, listeners, and scenario adapters.
 * In production builds Next inlines NODE_ENV so dead branches can be eliminated.
 * Implementation delegates to portable core package.
 */
export const isDevToolboxEnabled = createNodeEnvDevToolboxEnabled();
